export const METHOD_LABELS = {
    GET: 'View',
    POST: 'Create',
    PUT: 'Replace',
    PATCH: 'Update',
    DELETE: 'Delete',
};

export const METHOD_HINTS = {
    GET: 'Read records in this area.',
    POST: 'Add new records.',
    PUT: 'Overwrite an existing record.',
    PATCH: 'Change part of an existing record.',
    DELETE: 'Remove records.',
};

export const methodLabel = (method) => METHOD_LABELS[method] || method;

export const scopeOf = (domain, method) => `${domain}:${method}`;

export const splitScope = (scope) => {
    const sep = String(scope).lastIndexOf(':');
    if (sep <= 0) return { domain: String(scope), method: '' };
    return { domain: String(scope).slice(0, sep), method: String(scope).slice(sep + 1) };
};

export const domainLabel = (domains, domain) => (domains || []).find((d) => d.domain === domain)?.label || domain;

export const writeMethodsOf = (entry) => (entry?.methods || []).filter((m) => m !== 'GET');

// Turns ['notification:GET','notification:PATCH'] into [{ label: 'Notifications', actions: 'View, Update' }]
export const groupScopes = (scopes, domains) => {
    const grouped = new Map();
    (scopes || []).forEach((scope) => {
        const { domain, method } = splitScope(scope);
        if (!grouped.has(domain)) grouped.set(domain, []);
        grouped.get(domain).push(method);
    });
    return [...grouped.entries()]
        .map(([domain, methods]) => ({
            domain,
            label: domainLabel(domains, domain),
            methods,
            actions: methods.map(methodLabel).join(', '),
        }))
        .sort((a, b) => a.label.localeCompare(b.label));
};

export const describeDomainSelection = (entry, selectedMethods) => {
    if (!selectedMethods.length) return 'No access';
    if (selectedMethods.length === (entry.methods || []).length) {
        return entry.methods.length === 1 ? 'View only' : 'Full access';
    }
    return selectedMethods.map(methodLabel).join(', ');
};
